export default __webpack_public_path__ + "static/media/heroSectionBackground.79c4e8a7.png";